import React from 'react'
import "../Footwear.js/ProductsMenFootwear.css";
import m1 from "../assets/m1.jpg";
import m2 from "../assets/m2.jpg";
import m3 from "../assets/m3.jpg";
import m4 from "../assets/m4.jpg";
import m5 from "../assets/m5.jpg";
import m6 from "../assets/m6.jpg";
import m7 from "../assets/m7.jpg";
import m8 from "../assets/m8.jpg";
import m9 from "../assets/m9.jpg";
import m10 from "../assets/m10.jpg";
import m11 from "../assets/m11.jpg";
import m12 from "../assets/m12.jpg";
import m13 from "../assets/m13.jpg";
import m14 from "../assets/m14.jpg";
import m15 from "../assets/m15.jpg";
import m16 from "../assets/m16.jpg";
import m17 from "../assets/m17.jpg";
import m18 from "../assets/m18.jpg";
import m19 from "../assets/m19.jpg";
import m20 from "../assets/m20.jpg";
import m21 from "../assets/m21.jpg";
import m22 from "../assets/m22.jpg";
import m23 from "../assets/m23.jpg";
import m24 from "../assets/m24.jpg";
import m25 from "../assets/m25.jpg";
import m26 from "../assets/m26.jpg";
import m27 from "../assets/m27.jpg";
import m28 from "../assets/m28.jpg";
import m29 from "../assets/m29.jpg";
import m30 from "../assets/m30.jpg";

export default function ProductsMenFootwear() {

    const productsMenFootwear = [
  {
    id: 1,
    name: "Model No.MS-725-1",
    image: m1,
    link: "/products/mens-footwear1",
  },
  {
    id: 2,
    name: "Model No.MS-725-2",
    image: m2,
    link: "/products/mens-footwear2",
  },
  {
    id: 3,
    name: "Model No.MS-725-3",
  
    image: m3,
    link: "/products/mens-footwear3",
  },
  {
    id: 4,
    name: "Model No.MS-725-4",
   
    image: m4,
    link: "/products/mens-footwear4",
  },
  {
    id: 5,
    name: "Model No.MS-725-5",
   
    image: m5,
    link: "/products/mens-footwear5",
  },
  {
    id: 6,
    name: "Model No.MS-725-6",
   
    image: m6,
    link: "/products/mens-footwear6",
  },

    {
    id: 7,
    name: "Model No.MS-725-7",
    
    image: m7,
    link: "/products/mens-footwear7",
  },
   {
    id: 8,
    name: "Model No.MS-725-8",
    image: m8,
    link: "/products/mens-footwear8",
  },
    {
    id: 9,
    name: "Model No.MS-725-9",
    image: m9,
    link: "/products/mens-footwear9",
  },
    {
    id: 10,
    name: "Model No.MS-725-10",
    image: m10,
    link: "/products/mens-footwear10",
  },
    {
    id: 11,
    name: "Model No.MS-725-11",
    image: m11,
    link: "/products/mens-footwear11",
  },
    {
    id: 12,
    name: "Model No.MS-725-12",
    image: m12,
    link: "/products/mens-footwear12",
  },
   {
    id: 13,
    name: "Model No.MS-725-13",
    image: m13,
    link: "/products/mens-footwear13",
  },
   {
    id: 14,
    name: "Model No.MS-725-14",
    image: m14,
    link: "/products/mens-footwear14",
  },
   {
    id: 15,
    name: "Model No.MS-725-15",
    image: m15,
    link: "/products/mens-footwear15",
  },

     {
    id: 16,
    name: "Model No.MS-725-16",
    image: m16,
    link: "/products/mens-footwear16",
  },
     {
    id: 17,
    name: "Model No.MS-725-17",
    image: m17,
    link: "/products/mens-footwear17",
  },
     {
    id: 18,
    name: "Model No.MS-725-18",
    image: m18,
    link: "/products/mens-footwear18",
  },
     {
    id: 19,
    name: "Model No.MS-725-19",
    image: m19,
    link: "/products/mens-footwear19",
  },
     {
    id: 20,
    name: "Model No.MS-725-20",
    image: m20,
    link: "/products/mens-footwear20",
  },
     {
    id: 21,
    name: "Model No.MS-725-21",
    image:m21,
    link: "/products/mens-footwear21",
  },
   {
    id: 22,
    name: "Model No.MS-725-22",
    image: m22,
    link: "/products/mens-footwear22",
  },
   {
    id: 23,
    name: "Model No.MS-725-23",
    image: m23,
    link: "/products/mens-footwear23",
  },
   {
    id: 24,
    name: "Model No.MS-725-24",
    image: m24,
    link: "/products/mens-footwear24",
  },
  {
    id: 25,
    name: "Model No.MS-725-25",
    image: m25,
    link: "/products/mens-footwear25",
  },
  {
    id: 26,
    name: "Model No.MS-725-26",
    image: m26,
    link: "/products/mens-footwear26",
  },
  {
    id: 27,
    name: "Model No.MS-725-27",
    image: m27,
    link: "/products/mens-footwear27",
  },

  {
    id: 28,
    name: "Model No.MS-725-28",
    image: m28,
    link: "/products/mens-footwear28",
  },

  {
    id: 29,
    name: "Model No.MS-725-29",
    image: m29,
    link: "/products/mens-footwear29",
  },

  {
    id: 30,
    name: "Model No.MS-725-30",
    image: m30,
    link: "/products/mens-footwear30",
  },
];
  return (
    <>
       <section className="pmf">
      <h1 style={{textAlign:"center",fontSize:"42px"}}>Men’s Footwear</h1>
      <div className="pmf__grid">
        {productsMenFootwear.map((p) => (
          <article key={p.id} className="pmf__card">
            <img className="pmf__image" src={p.image} alt={p.name} loading="lazy" />
            <h3 className="pmf__name">{p.name}</h3>
            <p className="pmf__desc">{p.description}</p>
            <a className="pmf__btn" href={p.link} aria-label={`View ${p.name}`}>
             Explore More
            </a>
          </article>
        ))}
      </div>
    </section>

    </>
  )
}
